import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from '../../../components/form/form.component';
import { useForm } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { create, updateUser } from '../../../redux/thunks/admin/users';
import {
  newEmployeeForm,
  employeeForm,
} from '../../../utils/form-configs/employees.form';

const EmployeeModal = ({ show, onClose, user }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { isCreating, isUpdating } = useSelector(
    (state) => state.entities.admin.users
  );
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    getValues,
    watch,
    clearErrors,
  } = useForm({
    defaultValues: user
      ? {
          email: user.email,
          name: user.name,
          role: user.roles[0],
          hourlyRate: user.hourlyRate || '',
          monthlyRate: user.monthlyRate || '',
        }
      : {},
  });

  useEffect(() => {
    watch(() => clearErrors('invalid'));
  }, [watch, clearErrors]);

  const onSubmit = (formData) => {
    const onSuccess = (message) => {
      enqueueSnackbar(message, { variant: 'success' });
      onClose();
    };
    const onFailure = (message) =>
      enqueueSnackbar(message, { variant: 'error' });

    if (
      (typeof formData.hourlyRate === 'string' &&
        !formData.hourlyRate.length) ||
      (typeof formData.hourlyRate === 'number' &&
        Number(formData.hourlyRate) <= 0)
    ) {
      delete formData.hourlyRate;
    }

    if (
      (typeof formData.monthlyRate === 'string' &&
        !formData.monthlyRate.length) ||
      (typeof formData.monthlyRate === 'number' &&
        Number(formData.monthlyRate) <= 0)
    ) {
      delete formData.monthlyRate;
    }

    if (!user) {
      dispatch(create({ formData, onSuccess, onFailure }));
    } else {
      dispatch(
        updateUser({
          formData: {
            _id: user._id,
            ...formData,
          },
          onSuccess,
          onFailure,
        })
      );
    }
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{user ? 'Edit' : 'Add'} Employee</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          form={user ? employeeForm : newEmployeeForm}
          useForm={{
            register,
            errors,
            setValue,
            getValues,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Close
        </Button>
        <Button
          variant='primary'
          onClick={handleSubmit(onSubmit)}
          disabled={!user ? isCreating : isUpdating[user._id]}
        >
          {user ? 'Edit' : 'Add'} Employee
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EmployeeModal;
